<template>
  <div class="main">
    <div class="header">
      <img src="@/assets/images/living-room-sofa.png" />
    </div>
    <off-market-form @signed-up="signedUp" v-if="!hasSignedUp" />
    <div class="form-section" v-else>
      <h1>Thank you, {{this.lead.firstname}}</h1>
      <p
        class="subheader"
      >A member from our team will be in touch.</p>
    </div>
  </div>
</template>

<script>
import OffMarketForm from "@/views/OffMarketForm.vue";

export default {
  name: "OffMarketSignUp",
  components: {
    OffMarketForm
  },
  data() {
    return {
      lead: null,
      hasSignedUp: false
    };
  },
  methods: {
    signedUp(event) {
      this.lead = event;
      this.hasSignedUp = true;
      this.$helpers.gaPageView("/off-market/thank-you");
    }
  }
};
</script>

<style scoped lang="scss">
.main {
  h1 {
    text-align: center;
    font-size: 32px;
    font-weight: 900;
    line-height: 40px;
    margin: 20px 0;
  }

  .header {
    background-color: #fff;
  }

  .form-section {
    padding: 10px 20px 30px;
    background-color: #fff;
    top: 300px;
    margin-bottom: 50px;

    .subheader {
      text-align: center;
    }
  }
}
@screen md {
  .main {
    min-width: 500px;
    padding-bottom: 100px;
    position: relative;

    h1 {
      margin: 40px 0;
    }

    .header {
      position: absolute;
      width: 85%;
      height: 50px;
      min-width: 850px;
      left: 0;
      right: 0;
      margin: auto;
    }

    .form-section {
      position: absolute;
      z-index: 10;
      width: 650px;
      left: 50%;
      padding: 10px 80px 30px;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 3px;
      box-shadow: -1px 12px 20px 0 rgba(164, 158, 158, 0.5);

      .form {
        width: 450px;
      }
    }
  }
}
</style>
